import React from "react";
import Layout from "Layout";
import Form from "./form";
import useApi from "Hooks/useApi";
import useError from "Hooks/useError";
import { message } from "constants/message";
import useAuth from "Hooks/useAuth";
import googleAnalytics from "fuction/googleAnalytics";

export default function Edit(props) {
  const { params } = props.match;
  const dictId = parseInt(params.id, 10);

  const { request } = useApi();
  const stateError = useError();
  const { state } = useAuth();
  const messages = message();
  const [dict, setDict] = React.useState(null);
  const [accountAttr, setAccountAttr] = React.useState(null);

  const handleSubmit = ({ name, desc, check_for, filteredWords, ignore_case }) => {
    request({
      method: "PUT",
      url: `config/:account_id/analysis/noises/${dictId}`,
      data: {
        name: name,
        desc: desc,
        check_for: check_for,
        words: filteredWords,
        ignore_case: ignore_case,
      },
    })
      .then((data) => {
        stateError.initialize();
        props.history.push("/config/dictionarysetting/noise?success=edit");
      })
      .catch((error) => {
        let errorMsg = messages.validation.common;
        // 辞書名重複
        if (error.response.data.errors?.name?.[0].error == "taken") {
          errorMsg = messages.errorMsg.duplicateDictName + "（" + error.response.data.errors.name[0].value + "）";
        }
        // 「実行待ち」または「実行中」ステータスのタスクに設定されている辞書は編集できません。
        if (error.response.status === 403) {
          errorMsg = messages.errorMsg.dictUneditable;
        }
        stateError.dispatch({
          type: "set",
          payload: {
            isError: true,
            errorMsg: errorMsg,
          },
        });
      });
  };

  const fetchData = () => {
    if (!state.user.account_id) {
      return;
    }
    // ノイズ辞書情報取得
    request({
      method: "GET",
      url: `config/:account_id/analysis/noises/${dictId}`,
    }).then((data) => {
      setDict(data);
    });
  };

  const fetchAccountAttr = () => {
    if (!state.user.account_id) {
      return;
    }
    // ノイズ辞書に登録できる検知語の最大数を取得する
    request({
      method: "POST",
      url: `config/:account_id/account`,
      data: {
        "attrs": [
          "max_noise_words",
        ]
      },
    }).then((result) => {
      setAccountAttr(result.data);
    });
  };

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder - ノイズ辞書編集";

    fetchData();
    fetchAccountAttr();
  }, [state.user.account_id]);

  React.useEffect(() => {
    googleAnalytics(props.location.pathname, state.user.account_id);
  }, [props.location.pathname]);

  return (
    <Layout
      content={
        <Form
          submit={handleSubmit}
          accountAttr={accountAttr}
          dict={dict}
          isEdit={true}
        />
      }
    />
  );
}
